// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Suspense, lazy } from 'react';

const AtpDatePicker = lazy(() => import('./picker'));

export default function DatePicker(props) {
  return (
    <Suspense fallback={<div />}>
      <AtpDatePicker cancelText="Cancel" {...props} />
    </Suspense>
  );
}
